import { createReducer, on } from "@ngrx/store";
import { NavigationState, initialNavigationState } from "./navigation.state";
import { NavigationActions } from "./navigation.actions";

// **************************************************************************
// NAVIGATION REDUCER (standalone feature store)
// **************************************************************************

export const navigationReducer = createReducer(
    initialNavigationState,

    on(NavigationActions.setView, (state, { view, activeTab, url }) => ({
        ...state,
        view,
        activeTab,
        currentUrl: url,
        hasNavigated: true,
    })),

    on(NavigationActions.setSidebarExpanded, (state, { expanded }) => ({
        ...state,
        sidebarExpanded: expanded,
    })),

    on(NavigationActions.togglePageAside, (state) => ({
        ...state,
        asideExpanded: !state.asideExpanded,
    })),

    on(NavigationActions.setAsideTab, (state, { tab }) => ({
        ...state,
        asideTab: tab,
    })),

    on(NavigationActions.toggleSettingsDrawer, (state) => ({
        ...state,
        settingsDrawerVisible: !state.settingsDrawerVisible,
    })),

    // Sidebar group accordion: toggle open/closed, only one open at a time
    on(NavigationActions.toggleSidebarGroup, (state, { group }) => ({
        ...state,
        expandedSidebarGroup: state.expandedSidebarGroup === group ? null : group,
    })),

    // Expand a specific group (used by auto-open on navigation)
    on(NavigationActions.expandSidebarGroup, (state, { group }) => ({
        ...state,
        expandedSidebarGroup: group,
    })),
);
